import { render } from "./EmptyAreas.vue?vue&type=template&id=5c6f4df2"
import script from "./EmptyAreas.vue?vue&type=script&lang=js"
export * from "./EmptyAreas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__